<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <TableGuia/>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableGuia from '@/router/views/contribuinte/financeiro/components/table-guia'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "DUAMs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableGuia
  },
  data() {
    return {
      title: "Lista de Documento Único de Arrecadação Municipal (DUAM)",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAMs',
          active: true,
        },
      ],
    };
  }
};
</script>


